<button
  type="button"
  class="theme-toggle"
  [attr.aria-label]="(theme === 'dark' ? 'themeToggle.toLight' : 'themeToggle.toDark') | translate"
  (click)="toggle()">
  @if (theme === 'dark') {
    <app-icon name="sun" [size]="17" />
  } @else {
    <app-icon name="moon" [size]="17" />
  }
</button>
